
import { mapGetters } from 'vuex'
import AboutDemographicBlock from './AboutDemographicBlock.vue'
import MedicareSituation from './MedicareSituation.vue'

export default {
    components: { AboutDemographicBlock, MedicareSituation },
    props: {
        target: { type: Object, required: true },
        isPrimary: { type: Boolean, default: true },
        orgName: { type: String, default: '' },
        showEmployerRel: { type: Boolean, default: false },
        gate: { type: Boolean, default: false },
        // #679 Phase 2: new client + AEP plan review (see MedicareSituation).
        planReview: { type: Boolean, default: false },
    },
    computed: {
        // groupRelationships ({ value: RelationshipToGroup enum, text }) is the
        // Salesforce-synced store getter. Replaces the old free-text EMPLOYER_REL
        // list, whose option had no :value — so it had been storing the label
        // text into group_relationship instead of the enum value.
        ...mapGetters(['groupRelationships']),
        firstName () {
            return (this.target.first || this.target.first_name || '').trim() || 'this guest'
        },
        filteredGroupRelationships () {
            return this.groupRelationships.filter((gr) => {
                return !['ACQUAINTANCE_OF_EMPLOYEE', 'REFERRED_BY_CLIENT'].includes(gr.value)
            })
        }
    },
}
